import type {
  ProductCard,
  SearchProductsResponse,
} from "@/types/ingestedProduct";
import type { ProductRef } from "@/types/propagation";

import { productDetailsFromIngested } from "@/api/creativesphere/productSeed";

// Well under the catalog's 500 page size, so a chunk never paginates.
export const HYDRATE_CHUNK_SIZE = 50;

export type FetchProductsByIds = (
  productIds: string[],
) => Promise<SearchProductsResponse>;

export async function hydrateGroupProducts(
  cards: Pick<ProductCard, "product_id" | "title" | "image_url">[],
  fetchProducts: FetchProductsByIds,
): Promise<ProductRef[]> {
  const ids = cards.map((c) => c.product_id);
  const chunks: string[][] = [];
  for (let i = 0; i < ids.length; i += HYDRATE_CHUNK_SIZE) {
    chunks.push(ids.slice(i, i + HYDRATE_CHUNK_SIZE));
  }
  const responses = await Promise.all(
    chunks.map((chunk) => fetchProducts(chunk)),
  );
  if (responses.some((r) => r.next !== null)) {
    throw new Error(
      "Catalog lookup paginated a chunk; increase page size or lower HYDRATE_CHUNK_SIZE",
    );
  }
  const byId = new Map(
    responses
      .flatMap((r) => r.products)
      .map((p) => [p.vendor_product_id, p] as const),
  );
  return cards.map((card) => {
    const full = byId.get(card.product_id);
    return {
      vendor_product_id: card.product_id,
      vendor_variant_id: card.product_id,
      image_url: card.image_url,
      title: card.title,
      ...(full ? productDetailsFromIngested(full) : {}),
    };
  });
}
